// NOTE: 現状PCのみで使用。将来的にSPもこちらのsliceを使用する
import { createSlice } from '@reduxjs/toolkit';

/**
 * 初期型
 */
export interface CanonicalState {
  canonicalUrl: string | null;
}

// 初期状態
export const canonicalInitialState: CanonicalState = {
  canonicalUrl: null,
};

/**
 * App Slice
 * @remarks アプリケーションで保持したい情報
 *          例）ユーザー情報
 */
export const canonicalSlice = createSlice({
  name: 'canonical',
  initialState: canonicalInitialState,
  reducers: {
    setCanonicalUrl: (state, action) => {
      state.canonicalUrl = action.payload;
    },
  },
});

interface State {
  canonical: CanonicalState;
}

export const { setCanonicalUrl } = canonicalSlice.actions;

// selector
/**
 * appCanonicalUrlSelector
 * @param state
 */
export const appCanonicalUrlSelector = <S extends State>(state: S) =>
  state.canonical.canonicalUrl;

// reducer
export const canonicalReducer = canonicalSlice.reducer;

/**
 * canonicalUrlSelector
 * @param state
 */
export const canonicalUrlSelector = <S extends State>(state: S) =>
  state.canonical?.canonicalUrl;
